import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';

import { LoginComponent } from './pages/login/login.component';
import { UnauthorizedComponent } from '@pages/error-pages/unauthorized/unauthorized.component';
import { ForbiddenComponent } from '@pages/error-pages/forbidden/forbidden.component';
import { NotFoundComponent } from '@pages/error-pages/not-found/not-found.component';

const config = {
    onSameUrlNavigation: 'reload'
} as ExtraOptions;

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: '401', component: UnauthorizedComponent },
  { path: '403', component: ForbiddenComponent },
  { path: '404', component: NotFoundComponent },
  { path: '**', redirectTo: '404' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
